import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import MobileSidebar from "../Sidebar/MobileSidebar";
import './mainlayout.css';

function MainLayout() {
  return (
    <div className="mainlayoutclass">
      {/* Desktop Sidebar */}
      <div className="slideMenuDisplayaction">
        <Sidebar />
      </div>

      {/* Mobile Sidebar */}
      <div className="slideMenuMobileDisplayaction">
        <MobileSidebar />
      </div>

      {/* Main Content */}
      <div className="main-content">
        <div className="child-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default MainLayout;
